import { render, staticRenderFns } from "./mybaojia.vue?vue&type=template&id=3ef6bb0c&scoped=true&"
import script from "./mybaojia.vue?vue&type=script&lang=js&"
export * from "./mybaojia.vue?vue&type=script&lang=js&"
import style0 from "./mybaojia.vue?vue&type=style&index=0&id=3ef6bb0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6bb0c",
  null
  
)

export default component.exports